import React from 'react';
import SearchIcon from 'src/assets/images/icons/search-normal-grey.svg';

interface HelpSearchInputProps {
  placeholder?: string;
  onSearch?: (value: string) => void;
  className?: string;
}

export const HelpSearchInput: React.FC<HelpSearchInputProps> = ({ placeholder = 'Search help topics...', onSearch, className = '' }) => {
  return (
    <div className={`relative w-full max-w-2xl mx-auto ${className}`}>
      <div className='absolute inset-y-0 left-0 pl-16 flex items-center pointer-events-none'>
        <img src={SearchIcon} alt='search' className='w-20 h-20' />
      </div>
      <input
        type='text'
        className='block w-full pl-[45px] pr-16 py-10 bg-white border border-neutral-20 rounded-6 text-neutral-90
                 placeholder-neutral-60 focus:outline-none focus:ring-1 focus:ring-primary focus:border-transparent
                transition-all text-14 hover:border-primary'
        placeholder={placeholder}
        onChange={(e) => onSearch?.(e.target.value)}
      />
    </div>
  );
};
